export const components = {
  'to {{phone}}': 'a {{phone}}',
  'to {{email}}': 'a {{email}}',
  'Your data is protected': 'Tus datos están protegidos',
  'We use security best practices to keep your information safe':
    'Utilizamos las mejores prácticas de seguridad para mantener su información protegida',
  'Your data is masked': 'Tus datos están enmascarados',
  'For security reasons, we only show part of your registered information':
    'Por motivos de seguridad, solo mostramos parte de su información registrada.',

  'Doubts?': '¿Dudas?',

  'Here is some important information about password recovery':
    'Aquí hay información importante sobre la recuperación de contraseña',

  'Go to login': 'Ir al inicio de sesión',

  'No one at Vialaser will have access to your new password':
    'Nadie en Vialaser tendrá acceso a tu nueva contraseña',

  'Valid code': 'Código válido',
  'The verification code is valid for {{time}} minutes':
    'El código de verificación es válido durante {{time}} minutos',

  "Don't share your code": 'No compartas tu código',
  'Never share your verification code with third parties':
    'Nunca compartas tu código de verificación con terceros',

  'Need help?': '¿Necesitas ayuda?',
  'Contact our support team': 'Contacta a nuestro equipo de soporte',
};
